module.exports = __webpack_public_path__ + "static/media/developerPic.fae1756a.png";